export default __webpack_public_path__ + "static/media/use_action_back_hk.05c6d59c.png";